import { Link } from "react-router-dom";
import useMediaQuery from "@material-ui/core/useMediaQuery";

import useStyles from "./header.styles";

import logo from "../../assets/logos/logo.png";

import SearchIcon from "../../assets/icons/search-icon";
import UserIcon from "../../assets/icons/user-icon";
import CheckoutIcon from "../../assets/icons/checkout-icon";
import NavForMobile from "../nav-for-mobile";

const Header = () => {
  const matches = useMediaQuery("(min-width:1200px)");

  const classes = useStyles({ matches });

  return matches ? (
    <div className={classes.headerContainer}>
      <div className={classes.logoContainer}>
        <Link to="/">
          <img src={logo} alt="Logo" />
        </Link>
      </div>
      <div className={classes.rightSideContainer}>
        <div className={classes.partnerContainer}>
          <Link to="/">Become A Partner</Link>
        </div>
        <div className={classes.menuContainer}>
          <Link to="/">
            <SearchIcon width="24" height="24" />
          </Link>
          <Link to="/">
            <UserIcon width="40" height="40" />
          </Link>
          <Link to="/checkout">
            <CheckoutIcon width="32" height="32" />
          </Link>
          {/* <Link to="/admin">Admin</Link> */}
        </div>
      </div>
    </div>
  ) : (
    <div className={classes.headerContainer}>
      <div className={classes.leftSideContainer}>
        <div className={classes.menuContainer}>
          <NavForMobile />
          <Link to="/">
            <SearchIcon width="30" height="30" />
          </Link>
        </div>
      </div>
      <div className={classes.logoContainer}>
        <Link to="/">
          <img src={logo} alt="Logo" />
        </Link>
      </div>
      <div className={classes.rightSideContainer}>
        <div className={classes.menuContainer}>
          <Link to="/">
            <UserIcon width="44" height="44" />
          </Link>
          <Link to="/checkout">
            <CheckoutIcon width="36" height="36" />
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Header;
